import StackKit from "@/shared/components/kit/stack";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import { TextField } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { toEnglishNumber, toPersianNumber } from "@/hooks/useThousandsSeparator";
import AdapterMomentJalali from "@/shared/components/common/datePeacker";
import moment from "jalali-moment";
/**
 * AddSinglUser
 *
 * کامپوننت برای افزودن یک کاربر به صورت انفرادی در سامانه پولی پی .
 * این کامپوننت شامل:
 * - نمایش متن راهنما
 * - فرم شامل فیلدهای کد ملی، شماره تماس و تاریخ تولد
 * - استفاده از React Hook Form برای مدیریت فرم
 * - کنترل ورودی‌ها برای اعداد فارسی و انگلیسی
 * - تاریخ‌گیر Jalali با امکان انتخاب تاریخ
 *
 * ویژگی‌های واکنش‌گرا:
 * - فیلدها در موبایل به صورت ستونی نمایش داده می‌شوند
 * - دکمه‌ها و تاریخ‌گیر در موبایل عرض کامل دارند
 *
 * @param selectedOption حالت انتخاب‌شده (اختیاری، برای والد کنترل می‌شود)
 * @param setSelectedOption تابع برای تغییر حالت انتخاب‌شده
 *
 * @returns JSX.Element
 */

export const AddSinglUser = ({selectedOption,setSelectedOption,}: {selectedOption: any;setSelectedOption: any;}) => {
  const {control,handleSubmit,formState: { errors },} = useForm<any>({});

  return (
    <StackKit gap={4} sx={{ width: "100%" }}>
      {/* Instruction Text */}
      <TypoGraphyKit variant="body1">
        پذیرنده گرامی؛ این بخش مخصوص کاربرانی میباشد که از قبل در سامانه{" "}
        پولی پی ثبت نام شده‌اند. لطفا برای افزودن کاربر به
        این سازمان؛ شماره تماس و کد ملی کاربر را وارد نمایید.
      </TypoGraphyKit>

      {/* Form Fields */}
      <StackKit gap={3} sx={{ width: "100%" }}>
        {/* کد ملی */}
        <Controller
          name="NID"
          control={control}
          render={({ field }) => (
            <StackKit direction={{ xs: "column", sm: "row" }} justifyContent="space-between" alignItems={{ xs: "flex-start", sm: "center" }} gap={1} sx={{ width: "100%" }}>
              <TypoGraphyKit variant="body1" sx={{ minWidth: "80px" }}>
                کد ملی
              </TypoGraphyKit>
              <TextField {...field} fullWidth value={field.value ? toPersianNumber(field.value) : ""}
                onChange={(e) => {
                  const englishNumber = toEnglishNumber(e.target.value);
                  const rawValue = englishNumber.replace(/[^0-9]/g, "");
                  if (rawValue.length <= 10) field.onChange(rawValue);
                }}
              />
            </StackKit>
          )}
        />

        {/* شماره تماس */}
        <Controller
          name="phoneNumber"
          control={control}
          render={({ field }) => (
            <StackKit direction={{ xs: "column", sm: "row" }} justifyContent="space-between" alignItems={{ xs: "flex-start", sm: "center" }} gap={1} sx={{ width: "100%" }}>
              <TypoGraphyKit variant="body1" sx={{ minWidth: "80px" }}>
                شماره تماس
              </TypoGraphyKit>
              <TextField {...field} fullWidth value={field.value ? toPersianNumber(field.value) : ""}
                onChange={(e) => {
                  const englishNumber = toEnglishNumber(e.target.value);
                  const rawValue = englishNumber.replace(/[^0-9]/g, "");
                  if (rawValue.length <= 11) field.onChange(rawValue);
                }}
              />
            </StackKit>
          )}
        />

        {/* تاریخ تولد */}
        <Controller name="birthday" control={control}
          render={({ field, fieldState }) => (
            <StackKit direction="column" gap={1} sx={{ width: "100%" }}>
              <StackKit direction={{ xs: "column", sm: "row" }} justifyContent="space-between" alignItems={{ xs: "flex-start", sm: "center" }} gap={1} sx={{ width: "100%" }}>
                <TypoGraphyKit variant="body1" sx={{ minWidth: "80px" }}>
                  تاریخ تولد
                </TypoGraphyKit>
                <StackKit sx={{ width: { xs: "100%", sm: "70%" } }} alignItems="end">
                  <AdapterMomentJalali sx={{width: "100%",justifyContent: "flex-end",height: "50px",}} widthProps="100%" heightProps="50px"
                    valueDate={field.value ? moment(field.value, "jYYYY/jMM/jDD") : null}
                    errorHandle={fieldState.error}
                    handleChange={(newValue: any) => {
                      const formatted = newValue?.format("jYYYY/jMM/jDD") || "";
                      field.onChange(formatted);
                    }}
                  />
                  {fieldState.error && (
                    <TypoGraphyKit variant="caption" sx={{ color: "#d32f2f", textAlign: "right" }}>
                      {fieldState.error.message}
                    </TypoGraphyKit>
                  )}
                </StackKit>
              </StackKit>
            </StackKit>
          )}
        />
      </StackKit>
    </StackKit>
  );
};

export default AddSinglUser;
